<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'EmployeeAccount_Title' | translateWF: 'Employees' }}</h1>
        <div class="page__title_buttons">
          @if (canEdit) {
            <p-button [label]="'EmployeeAccount_Add' | translateWF: 'Add employee'" icon="pi pi-plus" (click)="openAdd()" />
          }
        </div>
      </div>
      <p class="text-sm text-[var(--p-text-muted-color)]">
        {{ 'EmployeeAccount_Subtitle' | translateWF: 'Employees enabled for trips and advances. Only an active employee here can be put on a trip.' }}
      </p>
    </div>

    <div class="grid grid-cols-12 gap-[2rem]">
      <div class="col-span-12 md:col-span-3 xl:col-span-3">
        @if (filterConfig(); as config) {
          <csl-dynamic-filters [filterConfig]="config" [state]="filterState" />
        }
      </div>

      <div class="col-span-12 md:col-span-9 xl:col-span-9">
        <p-table [value]="items()" dataKey="id" [lazy]="true" (onSort)="onSort($event)" [rowHover]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="employeeCode" style="width: 10rem">
                {{ 'EmployeeAccount_Col_Code' | translateWF: 'Code' }}
                <p-sortIcon field="employeeCode" />
              </th>
              <th pSortableColumn="name">
                {{ 'EmployeeAccount_Col_Name' | translateWF: 'Name' }}
                <p-sortIcon field="name" />
              </th>
              <th pSortableColumn="username">
                {{ 'EmployeeAccount_Col_User' | translateWF: 'Nexus user' }}
                <p-sortIcon field="username" />
              </th>
              <th>{{ 'EmployeeAccount_Col_AdvanceAccount' | translateWF: 'Advance account' }}</th>
              <th>{{ 'EmployeeAccount_Col_ApAccount' | translateWF: 'Payable account' }}</th>
              <th pSortableColumn="isActive" style="width: 9rem">
                {{ 'Status' | translateWF: 'Status' }}
                <p-sortIcon field="isActive" />
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData>
            @let row = getRow(rowData);
            <tr>
              <td>
                <a class="cs-table-link font-mono" (click)="redirectToDetails(row.id)">{{ row.employeeCode }}</a>
              </td>
              <td>{{ row.name }}</td>
              <td>{{ row.username ?? '—' }}</td>
              <td class="font-mono">{{ row.accounting.advanceGlAccount.number ?? '—' }}</td>
              <td class="font-mono">{{ row.accounting.apGlAccount.number ?? '—' }}</td>
              <td>
                <p-tag
                  [severity]="row.accounting.isActive ? 'success' : 'secondary'"
                  [value]="row.accounting.isActive ? ('EmployeeAccount_Active' | translateWF: 'Active') : ('EmployeeAccount_Inactive' | translateWF: 'Inactive')"
                />
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center">{{ 'EmployeeAccount_Empty' | translateWF: 'No employees enabled yet.' }}</td>
            </tr>
          </ng-template>
        </p-table>
        <p-paginator
          [rows]="pageSize()"
          [totalRecords]="totalRecords()"
          [first]="(currentPage() - 1) * pageSize()"
          (onPageChange)="onPageChange($event)"
          [rowsPerPageOptions]="[25, 50, 100]"
        />
      </div>
    </div>
  </div>
</main>
